var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: "智能识别",
            visible: _vm.Open,
            width: "580px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.Open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-width": "100px",
                model: _vm.form,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "营业执照", prop: "imgArr" } },
                [
                  _c(
                    "div",
                    { staticClass: "flex-y" },
                    [
                      _c("UploadFile", {
                        attrs: {
                          type: "SUPPLIER_BUSINESS_LICENSE",
                          multiple: false,
                          "btn-text": "上传图片",
                          "file-type": [
                            "png",
                            "jpg",
                            "jpeg",
                            "jpe",
                            "bmp",
                            "gif",
                            "tiff",
                            "tif",
                            "webp",
                            "jpe",
                            "jpe",
                          ],
                        },
                        on: { uploadSuccess: _vm.uploadSuccess },
                      }),
                      _c("div", { staticClass: "f12 text-muted" }, [
                        _vm._v(
                          " 支持格式：png / jpg / jpeg / jpe / bmp / gif / tiff / tif / webp 等，图片大小不超过10M，最长边不超过8192像素！ "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt10 flex-x" },
                        _vm._l(_vm.form.imgArr, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "pos mr10" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "deleteurl",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemoveImg(index)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-close",
                                  }),
                                ]
                              ),
                              _c("el-image", {
                                staticStyle: {
                                  width: "100px",
                                  height: "100px",
                                },
                                attrs: {
                                  fit: "cover",
                                  "preview-src-list": [item.attachmentUrl],
                                  src: item.attachmentUrl,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.dialogConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }